//
//
//
//
//
//
//
//
//

const {DateTime} = require("luxon");

function fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}
function hmsToSecondsOnly(str) {
    var p = str.split(':'),
        s = 0, m = 1;

    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }

    return s;
}
export default {
    props: {
        event: {
            type: Object,
        },        
        sport: {
            type: Object
        },
        wrapperClass: {
            type: String,
            default: 'text-primary-500'
        },
        liveClass: {
            type: String,
            default: 'font-normal   font-monobak'
        }
    },
    computed: {
        time() {

            let currentPhase = _.camelCase(_.get(this.event, 'matchSummary.currentPhase'));
            let matchTime = _.get(this.event, 'matchSummary.startTimes.'+currentPhase);

            let seconds = DateTime.now().diff(DateTime.fromISO(matchTime), 'second');
            if(currentPhase == 'secondHalf') {
                seconds += hmsToSecondsOnly( _.get(this.event, 'matchSummary.normalTimeHalfDuration'))
            }
            
            if(seconds == 0) {
                //return this.$t('Expired')
            }
           return matchTime;
           return currentPhase + ' ' + fmtMSS(seconds);
        },
    },
    methods: {
        goBack() {
            this.$router.back()
        }
  }
}
